import { createContext } from 'react';
import type { GoogleUser } from '../services/googleAuth';

export interface AuthContextType {
  user: GoogleUser | null;
  isAuthenticated: boolean;
  isAuthorized: boolean;
  isLoading: boolean;
  login: () => Promise<void>;
  logout: () => void;
  error: string | null;
  isScriptLoaded: boolean;
  handleGoogleResponse: (response: { credential: string }) => void;
}

export const AuthContext = createContext<AuthContextType | null>(null);
